import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  Grid,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Avatar,
  Icon,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  apiUrl,
  loadScript,
  validateEmail,
  updateHeight,
  mobileCheck,
} from "../common";
import "./index.css";
import * as d3 from "d3";
import PoweredBy from "../powered-by";
import { mode } from "d3";

const maxWidth = Math.min(500, window.innerWidth * 0.88);

const useStyles = makeStyles((theme) => ({
  close: {
    position: "absolute",
    top: 8,
    right: 8,
    background: "#0000000d",
    cursor: "pointer",
    color: "#fff",
  },
  button: {
    fontWeight: "bold",
    borderRadius: "0",
    color: "#fff",
  },
  dark: {
    color: "#333",
    borderColor: "#333",
  },
  light: {
    color: "#fff",
    borderColor: "#fff",
  },
  //spin wheel
  chartWidth: {
    width: maxWidth + "px",
    height: maxWidth + "px",
  },
  form: {
    background: "#f5f8fa",
    padding: "16px",
    borderRadius: "6px",
  },
}));

// PURE FUNCTIONS
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

const maxHeight = maxWidth;

let wheel;
let data;
let model;
// SYNC FUNCTIONS
function render(m) {
  model = m;
  data = model.wheelFortuneGifts;
  if (data.length % 2 != 0) data.push({ name: "Chúc bạn may mắn", winRate: 0 });
  //console.log(model);
  const isMobile = mobileCheck();
  const pd = 16;
  const padding = { top: pd, right: pd, bottom: pd, left: pd };
  const width = maxWidth - padding.left - padding.right;
  const height = maxHeight - padding.top - padding.bottom;
  const radius = Math.min(width, height) / 2;
  const color = d3.scaleOrdinal([model.color, model.color + "BF"]);

  //center desktop direct
  if (!isMobile && model.parent.direct) {
    document.getElementsByClassName("MuiBox-root")[0].style.transform =
      "translateY(25%)";
  }
  let svgWheel = document.getElementById("svgWheel");
  if (svgWheel) svgWheel.remove();
  let fontSize = isMobile ? "12px" : "18px";
  let svg = d3.select("#chart").selectAll("svg").data([null]);
  svg = svg
    .enter()
    .append("svg")
    .merge(svg)
    .data([data])
    .attr("id", "svgWheel")
    .attr("width", maxWidth)
    .attr("height", maxHeight);

  const container = svg
    .append("g")
    .attr("class", "chartcontainer")
    .attr(
      "transform",
      `translate(${width / 2 + padding.left},${height / 2 + padding.top})`
    );

  wheel = container.append("g").attr("class", "wheel");

  const pie = d3
    .pie()
    .sort(null)
    .value(function (d) {
      return 1;
    });

  const arc = d3.arc().innerRadius(0).outerRadius(radius);

  const arcs = wheel
    .selectAll("g.slice")
    .data(pie)
    .enter()
    .append("g")
    .attr("class", "slice");

  arcs
    .append("path")
    .attr("fill", function (d, i) {
      return color(i);
    })
    .attr("d", function (d) {
      return arc(d);
    });

  arcs
    .append("text")
    .attr("transform", function (d) {
      d.innerRadius = 0;
      d.outerRadius = radius;
      d.angle = (d.startAngle + d.endAngle) / 2;
      return `rotate(${
        (d.angle * 180) / Math.PI - 90
      })translate(${d.outerRadius - 10})`;
    })
    .attr("text-anchor", "end")
    .text(function (d, i) {
      return data[i].name;
    })
    .style("font-size", fontSize);

  // arrow
  svg
    .append("g")
    .attr("class", "arrow")
    .attr(
      "transform",
      `translate(${(width + padding.left + padding.right) / 2 - 15}, 12)`
    )
    .append("path")
    .attr("d", `M0 0 H30 L 15 ${(Math.sqrt(3) / 2) * 30}Z`)
    .style("fill", "#E60023");
  document.documentElement.style.setProperty("--color-custom", model.color);
  //document.documentElement.style.setProperty("--color-bg", model.color + "40");

  model.image = model.image
    ? model.image
    : "https://betacdn.ezca.asia/img/wheel-fortune/bg.jpg";
  document.body.style.background = `url(${model.image}) no-repeat`; //getComputedStyle(document.documentElement).getPropertyValue("--color-bg");
  if (!isMobile) document.body.style.backgroundSize = "cover";

  let result = d3.select("#result").data([null]);
  result = result
    .enter()
    .append("text")
    .attr("class", "result")
    .merge(result)
    //.text("EzCa")
    .style("color", model.color)
    .style("max-width", isMobile ? "50px" : "80px")
    .style("max-height", isMobile ? "50px" : "80px")
    .style("font-size", isMobile ? "10px" : "28px")
    .style("font-weight", "700");
}
var rotation;
// FUNCTIONS
function spin(gift) {
  const spins = 5;
  const degrees = spins * 360;
  const piedegree = 360 / data.length;
  const randomPieMovement = getRandomInt(1, piedegree);
  rotation =
    (data.length - gift.index) * piedegree - randomPieMovement + degrees;

  wheel
    .transition()
    .duration(5000)
    .attrTween("transform", rotTween)
    .ease(d3.easeCircleOut)
    .on("end", function () {
      let name = d3.select(".spin-result-name").data([null]);
      name = name
        .enter()
        .append("text")
        .attr("class", "")
        .merge(name)
        .text(
          `Bạn đã quay vào ô: ${data[gift.index].name}${
            gift.code ? ". Mã nhận thưởng: " + gift.code : ""
          }`
        );

      let message = d3.select(".spin-result-message").data([null]);
      message = message
        .enter()
        .append("text")
        .attr("class", "")
        .merge(message)
        .text(`${gift.code ? model.winMessage : model.loseMessage}`);

      let details = d3.select("#modal").data([null]);
      details = details.enter().merge(details).style("display", "block");
    });
}

function rotTween() {
  let i = d3.interpolate(0, rotation);
  return function (t) {
    return `rotate(${i(t)})`;
  };
}

function closeModal() {
  document.getElementById("modal").style.display = "none";
}

function outsideClick(e) {
  if (e.target == document.getElementById("modal")) {
    document.getElementById("modal").style.display = "none";
  }
}

const WheelFortune = (props) => {
  const classes = useStyles();
  const [key, setKey] = useState("");
  const [helperText, setHelperText] = useState("");
  const [label, setLabel] = useState("");
  const { id, wid } = useParams();
  const [model, setModel] = useState();
  const messageType = "wheel-fortune";
  const playTypes = {
    phone: 1,
    email: 2,
    facebook: 3,
    zalo: 5,
    none: 6,
  };
  useEffect(() => {
    if (!model) {
      if (wid) {
        //directLink
        fetch(`${apiUrl}/api/public/getdata/${messageType}/${id}/${wid}`)
          .then((response) => {
            return response.json();
          })
          .then((res) => {
            if (res.success) {
              let model = res.data.model;
              model.parent = {
                //uid:
                wid: model.websiteId,
                location: "",
                dh: "",
                isMobile: res.data.isMobile || window.innerWidth < 600,
                direct: true,
              };
              setModel(model);
            }
          });
      } else {
        window.parent.postMessage(
          { type: messageType, key: "getData", value: { id: id } },
          "*"
        );

        window.addEventListener("message", (event) => {
          let data = event.data;
          if (data.type !== messageType) return;
          //console.log(data.value);
          if (data.key == "setData") {
            setModel(data.value);
            updateHeight(messageType, { id });
            if (id) {
              fetch(`${apiUrl}/api/public/UpdateCount/${id}`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  type: messageType,
                  countView: true,
                }),
              });
            }
          }
        });
      }
    } else {
      window.addEventListener("click", outsideClick);
      render(model);
      changeLabel();
    }
    //console.log(model);
  }, [model]);

  const handleClose = () => {
    if (model.parent.isPreview) return;

    window.parent.postMessage(
      { type: messageType, key: "close", value: { id: model.id } },
      "*"
    );
  };

  const changeLabel = () => {
    switch (model.playType) {
      case playTypes.email:
        setLabel("Nhận thưởng bằng email");
        break;
      case playTypes.phone:
        setLabel("Nhận thưởng bằng số điện thoại");
        break;
      case playTypes.zalo:
        setLabel("Nhận thưởng bằng zalo");
        break;
      default:
        break;
    }
  };

  const changeKey = (event) => {
    let value = event.target.value;
    setKey(value);
    setHelperText(value ? "" : "Vui lòng nhập thông tin");
  };

  const validateKey = (value) => {
    if (model.playType == playTypes.none) return;

    let msg = "";
    if (!value) msg = "Vui lòng nhập thông tin";
    else {
      switch (model.playType) {
        case playTypes.email:
          msg = validateEmail(value)
            ? ""
            : "Email không hợp lệ. Ví dụ: ezca.asia@gmail.com";
          break;
        case playTypes.phone:
          msg =
            isNaN(value) || value.length != 10
              ? "Số điện thoại không hợp lệ. Ví dụ: 0775258089"
              : "";
          break;
        default:
          break;
      }
    }

    setHelperText(msg);
    return msg;
  };

  const submit = () => {
    var msg = validateKey(key);
    if (msg) return;

    let param = {
      playType: model.playType,
      key,
      wid: model.parent?.wid ?? wid,
      uid: model.parent?.uid,
      location: model.parent?.location,
    };

    fetch(`${apiUrl}/api/public/SubmitWheelFortune/${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...param,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        if (res.success) {
          setKey("");
          spin(res.data);
        } else setHelperText(res.data);
      });
  };

  const getPlayTypeName = (playType) => {
    switch (playType) {
      case playTypes.phone:
        return "số điện thoại";
      case playTypes.email:
        return "email";
      default:
        return "";
    }
  };

  return (
    <Box p={2} maxWidth={1200} mx="auto">
      <Icon className={classes.close} onClick={handleClose}>
        close
      </Icon>
      <Grid container alignItems="center">
        <Grid item xs={12}></Grid>
        <Grid item xs={12} md={7}>
          <Box textAlign="center">
            <div id="chart" className={classes.chartWidth}>
              <div className={`chart__front ${classes.chartWidth}`}></div>
              {/* <div className={`chart__back ${classes.chartWidth}`}></div> */}
              <div id="result"></div>
            </div>
          </Box>
        </Grid>
        {model && (
          <Grid item xs={12} md={5} className={classes.form}>
            {model.playType == playTypes.zalo && (
              <Box>
                <FormControl component="fieldset">
                  <FormLabel component="legend">{label}</FormLabel>
                </FormControl>
              </Box>
            )}
            {(model.playType == playTypes.phone ||
              model.playType == playTypes.email) && (
              <TextField
                variant="outlined"
                fullWidth
                required
                name="key"
                label={label}
                value={key}
                onChange={changeKey}
                onBlur={(e) => {
                  validateKey(e.target.value);
                }}
                error={helperText != ""}
                helperText={helperText}
              />
            )}
            {model.playType == playTypes.none && helperText && (
              <Box>{helperText}</Box>
            )}
            <Box mt={1}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                type="button"
                className={classes.button}
                style={{
                  backgroundColor: model.color,
                }}
                onClick={submit}
                //disabled={helperText != "" || !key}
              >
                {model.buttonText ?? "Chơi ngay"}
              </Button>
            </Box>
          </Grid>
        )}
      </Grid>
      <div id="modal">
        <div className="modal-content">
          <div className="modal-header">
            <span className="closeBtn" onClick={closeModal}>
              &times;
            </span>
          </div>
          <div className="modal-body">
            <div className="modal-body-name modal-body-container">
              {/* <div className="modal-body-title">Bạn đã quay vào ô:</div> */}
              <div className="spin-result spin-result-name"></div>
            </div>
            <div className="modal-body-rank modal-body-container">
              <div className="spin-result spin-result-message"> </div>
            </div>
          </div>
        </div>
      </div>
      {model && !model?.parent?.isPreview && (
        <PoweredBy
          widget={messageType}
          color="#fff"
          dh={model.parent?.dh ?? ""}
        />
      )}
    </Box>
  );
};
export default WheelFortune;
